export const ROUTE_NAMES = {
    HOME_INSURANCE: {
        _MAIN: "/inicio",
        LANDING: "/inicio",
        STEP2: "/datos-iniciales-inmueble",
        STEP3: "/cotizacion",
        STEP4: "/datos-inmueble",
        STEP5: "/pago",
        CONFIRM1: "/confirmacion",
        THANKS: "/gracias",
    },
};
